// Libraries
import styled from 'styled-components'

interface IWrap {
  $minWidth?: string;
}

export const WrapSelect = styled.div`
  width: fit-content;
  position: relative;
  display: block;
  * {
    width: ${({ $minWidth: minWidth }: IWrap) => minWidth};
  }
  ::before {
    position: absolute;
    content: '';
    top: 50%;
    transform: translateY(-50%);
    right: 20px;
    display: block;
    background-image: url('/LowerArrow.svg');
    background-repeat: no-repeat;
    background-position: center;
    width: 20px;
    height: 20px;
    pointer-events: none;
  }
`;

export const Select = styled.select`
  width: fit-content;
  padding: 20px 55px 20px 20px;
  font-family: "Avenir Next Regular", sans-serif;
  font-size: 14px;
  line-height: 19px;
  color: #fff;
  background-color: rgba(255, 255, 255, 0.2);
  border: 1px solid #fff;
  box-sizing: border-box;
  letter-spacing: 0.8px;
  appearance: none;
  :focus {
    outline-color: #00a2ff;
  }
`;

export const Option = styled.option`
  background-color: #4598C6;
`;

